import PropTypes from "prop-types";
import React from "react";
import { VectorMap } from "react-jvectormap";
import "./jquery-jvectormap.scss";
import MapContainer from "../../../Components/Common/MapContainer";

const map = React.createRef(null);
const Vectormap = (props) => {
  return (
    <div style={{ width: props.width, height: 350 }}>
      <MapContainer />
    </div>
  );
};

Vectormap.propTypes = {
  color: PropTypes.string,
  value: PropTypes.any,
  width: PropTypes.any,
};

export default Vectormap;
